// eslint-disable-next-line import/no-cycle
import {
  WidgetTypeConfig,
  ConfigurationPanelStructureItemEnum,
  ComponentNameEnum,
  ElementPartTypeEnum,
  BackgroundImageOptionTypeEnum,
  TemplateStructureEnum,
} from '@/types';
// eslint-disable-next-line import/no-cycle
import getHorizontalSpacesFieldConfig from '@/components/template-builder/config/fields/horizontal-spaces-config';
// eslint-disable-next-line import/no-cycle
import getVerticalSpacesFieldConfig from '@/components/template-builder/config/fields/vertical-spaces-config';
// eslint-disable-next-line import/no-cycle
import getWysiwygEditorFieldConfig from '@/components/template-builder/config/fields/wysiwyg-editor-config';
// eslint-disable-next-line import/no-cycle
import elementVerticalAlignFieldConfig from '@/components/template-builder/config/fields/element-vertical-align-config';
// eslint-disable-next-line import/no-cycle
import variables from '@/components/template-builder/utils/variables-list';
// eslint-disable-next-line import/no-cycle
import {
  setContent,
  setCssProperty,
  setCssPropertyAndRemoveIfZero,
  setMediaDisplay,
  setBackgroundImage,
  setBackgroundImageWithVml,
  setBackgroundPositionFromGrid,
  updateVmlInsetOnPaddingChange,
  setVerticalAlignAndVml,
} from '@/components/template-builder/setters';
// eslint-disable-next-line import/no-cycle
import {
  getClassByName,
  getContent,
  getCssPropertyByName,
  isMediaDisplayAlreadyRestricted,
  getBackgroundImageValue,
  getBackgroundImageProperties,
  getBackgroundPositionAsGrid,
  getExplicitHeight,
} from '@/components/template-builder/getters';
// eslint-disable-next-line import/no-cycle
import getBackgroundImageFieldConfig from '@/components/template-builder/config/fields/background-image-config';
// eslint-disable-next-line import/no-cycle
import getColorFieldConfig from '@/components/template-builder/config/fields/color-config';
// eslint-disable-next-line import/no-cycle
import bordersFieldConfig from '@/components/template-builder/config/fields/borders-config';
// eslint-disable-next-line import/no-cycle
import mediaDisplayFieldConfig from '@/components/template-builder/config/fields/media-display-config';
// eslint-disable-next-line import/no-cycle
import { getTemplateIframeDocument } from '@/components/template-builder/utils/helpers';
// eslint-disable-next-line import/no-cycle
import { getDynamicStylesForSelector } from '@/components/template-builder/utils/parser';
// eslint-disable-next-line import/no-cycle
import { HIDE_MOBILE_ATTRIBUTE } from '@/components/template-builder/utils/constants';
// eslint-disable-next-line import/no-cycle
import getConditionsAndRepetitionGroup from '@/components/template-builder/config/fields/conditions-repetition-group-helper';
// eslint-disable-next-line import/no-cycle
import getPositionGridFieldConfig from '@/components/template-builder/config/fields/position-grid-config';
// eslint-disable-next-line import/no-cycle
import getWidgetCommonStylesGroup from '@/components/template-builder/config/fields/widget-common-styles-config';

const emailWidgetTextConfig: WidgetTypeConfig = {
  tabPanel: {
    label: 'templateBuilder.widgetsHeaders.text',
    items: [
      {
        type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
        label: 'templateBuilder.configs.widgetConfiguration',
        selector: 'body #spm_body #{ID}',
        items: [
          {
            label: 'templateBuilder.fields.wysiwygEditor',
            selector: '{SELECTOR}.spm_widget_text > tbody > tr > th .spm_rich_editor, {SELECTOR}.spm_widget_display_text > div.spm_rich_editor',
            properties: [{ name: 'content', getter: getContent, setters: [setContent] }],
            ...getWysiwygEditorFieldConfig('<div>Votre contenu ici</div>', variables.allVariables),
          },
        ],
      },
      {
        type: ConfigurationPanelStructureItemEnum.TAB_ITEM,
        tabItemType: TemplateStructureEnum.GROUP,
        label: 'templateBuilder.configs.widgetStyles',
        canSave: true,
        elementPartType: ElementPartTypeEnum.STYLES,
        tabPanel: {
          items: [
            {
              type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
              label: 'templateBuilder.configs.widgetBlockStyles',
              selector: 'body #spm_body #{ID}',
              items: [
                {
                  label: 'templateBuilder.fields.backgroundColor',
                  selector: '{SELECTOR} > tbody > tr > th .spm_rich_editor_wrapper',
                  properties: [{ name: 'background-color', getter: getCssPropertyByName, setters: [setCssProperty] }],
                  ...getColorFieldConfig(),
                },
                {
                  label: 'templateBuilder.fields.backgroundImage',
                  selector: '{SELECTOR} > tbody > tr > th .spm_rich_editor_wrapper',
                  fieldId: 'backgroundImage',
                  properties: [
                    { name: 'background-image', getter: getBackgroundImageValue, setters: [setBackgroundImageWithVml] },
                    { name: 'backgroundImageCustomSelector', getter: getBackgroundImageProperties, setters: [] },
                    { name: 'background-size', getter: getCssPropertyByName, setters: [setBackgroundImageWithVml] },
                    { name: 'background-repeat', getter: getCssPropertyByName, setters: [setBackgroundImageWithVml] },
                  ],
                  ...getBackgroundImageFieldConfig(BackgroundImageOptionTypeEnum.SIZE_REPEAT),
                  onToggleOff: (selector: string) => {
                    setBackgroundImageWithVml(selector, { name: 'background-image', value: 'none', getter: getBackgroundImageValue, setters: [] });
                  },
                  onToggleOn: (selector: string) => {
                    // When toggling on, apply the configured background image
                    const currentBgImage = getBackgroundImageValue(selector, 'background-image');
                    if (currentBgImage && currentBgImage !== 'none') {
                      setBackgroundImageWithVml(selector, { name: 'background-image', value: currentBgImage, getter: getBackgroundImageValue, setters: [] });
                    }
                  },
                },
                {
                  label: 'templateBuilder.fields.backgroundPosition',
                  selector: '{SELECTOR} > tbody > tr > th .spm_rich_editor_wrapper',
                  properties: [
                    { name: 'background-position', getter: getBackgroundPositionAsGrid, setters: [setBackgroundPositionFromGrid] },
                  ],
                  parentFieldId: 'backgroundImage',
                  isVisible: (items: any[], parentFieldId: string) => {
                    const property = items.find((item) => item.fieldId === parentFieldId);
                    if (property && Array.isArray(property.properties) && property.properties.length) {
                      const bgImage = property.properties.find((p: any) => p.name === 'background-image');
                      return bgImage && bgImage.value && bgImage.value !== 'none' && !bgImage.value.includes('none');
                    }
                    return false;
                  },
                  ...getPositionGridFieldConfig('mc', { allowCenter: true }),
                },
                {
                  label: 'templateBuilder.fields.height',
                  fieldId: 'textWidgetHeight',
                  selector: '{SELECTOR} .spm_rich_editor_wrapper, {SELECTOR} .spm_rich_editor_wrapper > tbody > tr > td',
                  properties: [
                    { name: 'height', getter: getCssPropertyByName, setters: [setCssProperty, setBackgroundImageWithVml] },
                    { name: 'explicit-height', getter: getExplicitHeight, setters: [] },
                  ],
                  componentName: ComponentNameEnum.STEPPER_PX_PERCENT_SLIDER,
                  options: {
                    px: {
                      min: 0,
                      max: 1000,
                      step: 1,
                      defaultValue: 0,
                      isDefaultUnitSelected: true,
                    },
                  },
                  onToggleOff: (selector: string) => {
                    // Update VML when height is toggled off
                    setBackgroundImageWithVml(selector, { name: 'height', value: '', getter: getCssPropertyByName, setters: [] });
                  },
                  onToggleOn: (selector: string) => {
                    // Update VML when height is toggled on - get current height value and apply it
                    const currentHeight = getCssPropertyByName(selector, 'height', false, false);
                    if (currentHeight && typeof currentHeight === 'object' && currentHeight.value) {
                      setBackgroundImageWithVml(selector, { name: 'height', value: currentHeight.value, getter: getCssPropertyByName, setters: [] });
                    }
                  },
                },
                {
                  label: 'templateBuilder.fields.verticalAlignment',
                  selector: '{SELECTOR} .spm_rich_editor_wrapper > tbody > tr > td',
                  properties: [
                    { name: 'vertical-align', getter: getCssPropertyByName, setters: [setVerticalAlignAndVml] },
                  ],
                  parentFieldId: 'textWidgetHeight',
                  isVisible: (items: any[], parentFieldId: string) => {
                    // Check if height is explicitly set using the explicit-height property
                    const heightField = items.find((item: any) => item.fieldId === parentFieldId);
                    if (heightField && heightField.properties) {
                      const explicitHeightProp = heightField.properties.find((p: any) => p.name === 'explicit-height');
                      const value = explicitHeightProp?.value;
                      // Show only if explicit height is defined (not empty)
                      return !!(value && value !== '');
                    }
                    return false;
                  },
                  onToggleOff: (selector: string) => {
                    setVerticalAlignAndVml(selector, { name: 'vertical-align', value: '', getter: getCssPropertyByName, setters: [] });
                  },
                  onToggleOn: (selector: string) => {
                    const currentAlign = getCssPropertyByName(selector, 'vertical-align', false, false);
                    if (currentAlign && typeof currentAlign === 'object' && currentAlign.value) {
                      setVerticalAlignAndVml(selector, { name: 'vertical-align', value: currentAlign.value, getter: getCssPropertyByName, setters: [] });
                    }
                  },
                  ...elementVerticalAlignFieldConfig,
                },
                {
                  label: 'templateBuilder.fields.internalMargins',
                  selector: '{SELECTOR} .spm_rich_editor_wrapper > tbody > tr > td',
                  properties: [
                    { name: 'padding-top', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero, updateVmlInsetOnPaddingChange] },
                    { name: 'padding-bottom', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero, updateVmlInsetOnPaddingChange] },
                    { name: 'padding-left', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero, updateVmlInsetOnPaddingChange] },
                    { name: 'padding-right', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero, updateVmlInsetOnPaddingChange] },
                  ],
                  componentName: ComponentNameEnum.SPACES,
                  onToggleOff: (selector: string) => {
                    setBackgroundImageWithVml(selector, { name: 'padding', value: '', getter: getCssPropertyByName, setters: [] });
                  },
                  onToggleOn: (selector: string) => {
                    const currentPadding = getCssPropertyByName(selector, 'padding', false, false);
                    if (currentPadding && typeof currentPadding === 'object' && currentPadding.value) {
                      setBackgroundImageWithVml(selector, { name: 'padding', value: currentPadding.value, getter: getCssPropertyByName, setters: [] });
                    }
                  },
                  options: {
                    ...getVerticalSpacesFieldConfig('padding').options,
                    ...getHorizontalSpacesFieldConfig('padding').options,
                  },
                },
                {
                  label: 'templateBuilder.fields.borders',
                  selector: '{SELECTOR} > tbody > tr > th .spm_rich_editor_wrapper',
                  properties: [
                    { name: 'border-color', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'border-style', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-width', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
                    { name: 'border-bottom-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'border-bottom-color', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-bottom-width', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-top-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'border-top-color', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-top-width', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-left-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'border-left-color', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-left-width', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-right-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'border-right-color', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-right-width', getter: getCssPropertyByName, setters: [] },
                  ],
                  ...bordersFieldConfig,
                },
              ],
            },
            getWidgetCommonStylesGroup('{SELECTOR} > tbody > tr > th'),
          ],
        },
      },
      getConditionsAndRepetitionGroup('body #spm_body #{ID}'),
    ],
  },
};

export default emailWidgetTextConfig;
